import { SwxTheme } from 'swx-atomic-component-lib'

const style = {
  containerStyle: `
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    box-sizing: border-box;
    width: 100%;
  `,
  contentBoxStyle: `
    padding: 48px;
    width: 100%;
    border-bottom: 1px solid #dee6ea;
  `,
  contentBoxTitleStyle: `
    margin-bottom: 20px;
    font-size: 16px;
    white-space: normal;
  `,
  magicCodeContainerStyle: `
    display: flex;
    max-width: 264px;
  `,
  magicCodeInputContainerStyle: `
    width: 100%;
    height: 44px;
  `,
  magicCodeInputStyle: `
    height: 44px;
    font-size: 20px;
    background-color: ${SwxTheme.palette.g200};
    color: ${SwxTheme.palette['secondary-dark']};
    border-radius: 22px;
    padding-left: 20px;
    border-color: transparent;
    text-transform: uppercase;

    &:focus {
      border-width: 1px;
      border-color: ${SwxTheme.palette.primary};
      box-shadow: 0 0 0 1px ${SwxTheme.palette.primary};
    }
  `,
  messageContainer: `
    font-size: 12px;
    justify-content: space-between;
  `,
  instruction: `
    white-space: normal;
    margin-top: 8px;
    word-wrap: break-word;
    overflow: unset;
    text-overflow: unset;
    font-size: 12px;
  `,
  resendCode: `
    color: ${SwxTheme.palette.primary};
    cursor: pointer;
    margin-top: 16px;
    font-size: 12px;
  `,
  ctaContainer: `
    display: flex;
    align-items: center;
    padding: 22px 48px;
    width: 100%;
    display: flex;
    box-shadow: none;
    border-radius: 0;
    background-color: ${SwxTheme.palette['secondary-light']};
    justify-content: flex-end;
  `,
  ctaMessage: `
    font-size: 14px;
    padding: 0;
    letter-spacing: 0.5px;
    list-style: none;
    margin-left: 10px;
  `,
  buttonPrimaryStyle: `
    min-width: 81px;
    margin-left: 20px;
  `,
  buttonFloatRight: `
    float: right;
  `,
  buttonCancelStyle: `
    min-width: 81px;
    margin-left: 20px;
    background-color: ${SwxTheme.palette.white};
  `,
  smallScreenButtonContainer: `
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    button {
      width: 100%;
      margin-left: 0px;
    }
    button:nth-child(1) {
      margin-top: 5px;
    }
  `
}

export default style
